var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.766 0l-1.722 1.722 5.286 5.284H0v2.458h17.331l-5.287 5.285 1.722 1.722L22 8.235 13.766 0z",
    fill: "#1A0B25"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjIgMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNzY2IDBMMTIuMDQ0NCAxLjcyMTYyTDE3LjMzIDcuMDA2MTNIMFY5LjQ2NDI1SDE3LjMzMTJMMTIuMDQ0NCAxNC43NDg4TDEzLjc2NiAxNi40NzE1TDIyIDguMjM1MTlMMTMuNzY2IDBaIiBmaWxsPSIjMUEwQjI1Ii8+Cjwvc3ZnPgo=";
export { SvgIconArrow as ReactComponent };